import { useState } from "react";
import { v4 as uuidv4 } from "uuid";

export function useKeyValueStore(initialState) {
  const initialArray = Object.entries(initialState).map(([key, value]) => ({
    id: uuidv4(),
    key: key,
    value: value,
  }));

  const [store, setStore] = useState(initialArray);

  const addCustomValue = (key, value, handleSnack) => {
    if (!key) {
      handleSnack(true, "Debes ingresar una llave");
      return;
    }
    if (!value) {
      handleSnack(true, "Debes ingresar un valor");
      return;
    }
    setStore((prev) => [...prev, { id: uuidv4(), key: key, value: value }]);
  };

  const updateKey = (id, newKey) => {
    setStore((prev) =>
      prev.map((item) => (item.id === id ? { ...item, key: newKey } : item))
    );
  };

  const updateValue = (id, newValue) => {
    setStore((prev) =>
      prev.map((item) => (item.id === id ? { ...item, value: newValue } : item))
    );
  };

  const removeKey = (id) => {
    setStore((prev) => prev.filter((item) => item.id !== id));
  };

  const getObjectStore = () => {
    return store.reduce(
      (acc, curr) => ({ ...acc, [curr.key]: curr.value }),
      {}
    );
  };

  return {
    store,
    setStore,
    addCustomValue,
    updateKey,
    updateValue,
    removeKey,
    getObjectStore,
  };
}
